import React, { useState, useEffect } from "react";
import Header from "../../Components/Header/Header";
import { useNavigate, useLocation } from "react-router-dom";

// ─── Chip-wise screen imports ─────────────────────────────────────────────────
import SubscriptionPlans  from "./SubscriptionPlans";
import Memberships        from "../Memberships/Memberships";
import Ambassador         from "../Ambassador/Ambassador";
import AmbassadorTrack    from "../AmbassadorTrack/AmbassadorTrack";
import History            from "../History/History";

// ─── Chips config ─────────────────────────────────────────────────────────────
const CHIPS = [
  { label: "PLANS",               route: "/PlanList"          },
  { label: "SUBSCRIPTIONS",       route: "/Memberships"       },
  { label: "AMBASSADOR REQUESTS", route: "/Ambassador"        },
  { label: "AMBASSADOR TRACK",    route: "/AmbassadorTrack"   },
  { label: "HISTORY",             route: "/History"           },
];

function getChipFromPath(pathname) {
  return CHIPS.find((c) => c.route === pathname) || CHIPS[0];
}

// ─── ChipBar ──────────────────────────────────────────────────────────────────
function ChipBar({ selected, onChange }) {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "2px",
        padding: "5px",
        margin: "15px",
        background: "rgba(6, 101, 228, 0.15)",
        border: "1px solid rgba(6, 101, 228, 0.35)",
        boxShadow: "0 4px 24px rgba(6, 101, 228, 0.15)",
        borderRadius: "999px",
        backdropFilter: "blur(8px)",
      }}
    >
      {CHIPS.map((c) => {
        const active = selected === c.label;
        return (
          <button
            key={c.label}
            onClick={() => onChange(c)}
            style={{
              height: "38px",
              padding: "0 22px",
              borderRadius: "999px",
              border: "none",
              background: active ? "rgba(6, 101, 228, 0.75)" : "transparent",
              color: active ? "#FFFFFF" : "rgba(255,255,255,0.55)",
              boxShadow: active ? "0 2px 12px rgba(6, 101, 228, 0.4)" : "none",
              fontSize: "12px",
              fontWeight: active ? "700" : "500",
              letterSpacing: "0.8px",
              textTransform: "uppercase",
              cursor: "pointer",
              transition: "all 0.2s ease",
              whiteSpace: "nowrap",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            {c.label}
          </button>
        );
      })}
    </div>
  );
}

// ─── Chip → Component map ─────────────────────────────────────────────────────
const CHIP_COMPONENTS = {
  "PLANS":               SubscriptionPlans,
  "SUBSCRIPTIONS":       Memberships,
  "AMBASSADOR REQUESTS": Ambassador,
  "AMBASSADOR TRACK":    AmbassadorTrack,
  "HISTORY":             History,
};

// ─── Main wrapper ─────────────────────────────────────────────────────────────
function SubscriptionManagement() {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedChip, setSelectedChip] = useState(
    () => getChipFromPath(location.pathname)
  );

  // Sync chip with browser back/forward
  useEffect(() => {
    const matched = getChipFromPath(location.pathname);
    if (matched.label !== selectedChip.label) setSelectedChip(matched);
    // eslint-disable-next-line
  }, [location.pathname]);

  const handleChipChange = (chip) => {
    setSelectedChip(chip);
    navigate(chip.route);
  };

  const ActiveScreen = CHIP_COMPONENTS[selectedChip.label] || SubscriptionPlans;

  return (
    <div>
      <Header name={"Subscription Management"} />

      {/* ChipBar — always visible on every chip */}
      <ChipBar selected={selectedChip.label} onChange={handleChipChange} />

      {/* Active chip content */}
      <ActiveScreen />
    </div>
  );
}

export default SubscriptionManagement;